import httpClient from '@utils/httpClient.js';

export function updateFooterApiCall({ id, content }) {
  const profileId = localStorage.getItem('unilinkProfileId');

  return httpClient.put(`api/profiles/${profileId}/email-marketing/block/footer`, {
    id,
    content,
  });
}
